"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _tool = require("@/utils/tool");

var _project = require("@/api/project");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'UploadImgComponent',
  props: {
    file: {
      type: [String, File],
      default: ''
    },
    dataType: {
      type: String,
      default: 'url' // url, file

    },
    path: {
      type: String,
      default: '' // 上传路径

    }
  },
  computed: {
    currentFile: {
      get: function get() {
        return this.file;
      },
      set: function set(val) {
        console.log('set cuuu', val);
        this.$emit('update:file', val);
      }
    }
  },
  methods: {
    getUrl: _tool.getUrl,
    changeFile: function changeFile(event) {
      var _this = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var e, file, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(_this.dataType, _this.path);
                e = event.srcElement || event.target;

                if (e.value) {
                  _context.next = 6;
                  break;
                }

                _this.currentFile = '';
                _context.next = 25;
                break;

              case 6:
                file = e.files[0];
                _context.t0 = _this.dataType;
                _context.next = _context.t0 === 'file' ? 10 : _context.t0 === 'url' ? 12 : _context.t0 === 'binary' ? 13 : 24;
                break;

              case 10:
                _this.currentFile = file;
                return _context.abrupt("break", 25);

              case 12:
                return _context.abrupt("break", 25);

              case 13:
                _context.t1 = _project.projectUploadImg;
                _context.t2 = Buffer;
                _context.next = 17;
                return file.arrayBuffer();

              case 17:
                _context.t3 = _context.sent;
                _context.t4 = _context.t2.from.call(_context.t2, _context.t3);
                _context.next = 21;
                return (0, _context.t1)(_context.t4);

              case 21:
                res = _context.sent;
                _this.currentFile = res.data.data;
                console.log(res);

              case 24:
                return _context.abrupt("break", 25);

              case 25:
                console.log(e.value);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    close: function close() {
      this.currentFile = '';
    }
  }
};
exports.default = _default;